import { render, staticRenderFns } from "./susResearches.vue?vue&type=template&id=e47bb6ee&"
import script from "./susResearches.vue?vue&type=script&lang=js&"
export * from "./susResearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports